import $ from "jquery";

import moment from 'moment';

export function doFixedTableHeader(mainTable, fixedHeader){
    let ths = mainTable.find("thead th")
        ,cloned = mainTable.find("thead").clone(true, true, true)
        ,clonedThs = cloned.find("th");

    if(!fixedHeader.find("thead").length)
        fixedHeader.find("table").append(cloned);
    else
        clonedThs = fixedHeader.find("th");

    for(let i=0,n=ths.length;i<n;i++){
        $(clonedThs[i]).width($(ths[i]).width());
    }
}

export function insertIf(condition, ...elements) {
    return condition ? elements : [];
}

export function hasNumber(str) {
  return /\d/.test(str);
}

export function extractNumberFromString(str) {
  return str.replace(/[^0-9]/g,'');
}

export function formatDate(date){
    return date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
}

export function isFutureDate(date) {
    return date.getTime() > new Date().getTime();
}

export function roundTime(date, duration, method) {
    return moment(Math[method]((+date) / (+duration)) * (+duration));
}

export function booleanConvert(val){
    return val===1 || val==="1" ? "Sim" : "Não";
}

export function statusBlockClass(val){
    return val==="1" ? "successBackground" : "dangerBackground";
}

export function statusTextClass(val){
    return val==="1" ? "successText" : "dangerText";
}

export function getVatValue(val, vat){
    const parsedVal = parseFloat(val);
    const parsedVat = parseFloat(vat / 100);

    return (parsedVal * parsedVat).toFixed(2);
}

export function getValueWithVat(val, vat){
    const parsedVal = parseFloat(val);
    const parsedVat = parseFloat(vat / 100);
    
    return (parsedVal / (1 - parsedVat)).toFixed(2);
}

export function getValueWithoutVat(val, vat){
    const parsedVal = parseFloat(val);
    const parsedVat = parseFloat(vat / 100);

    return (parsedVal * (1 - parsedVat)).toFixed(2);
}

export function sortNumber(a,b) {
    return a - b;
}

export function desc(a, b, orderBy) {
    const val1 = isNaN(a[orderBy]) ? a[orderBy]?.toLowerCase() : +a[orderBy];
    const val2 = isNaN(b[orderBy]) ? b[orderBy]?.toLowerCase() : +b[orderBy];
    
    if (val2 < val1) {
        return -1;
    }
    if (val2 > val1) {
        return 1;
    }
    return 0;
}

export function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

export function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

export function getDayOfWeekPT(day) {
    switch(day){
        case 1:
        case "1":
            day = "Segunda";
        break;
        case 2:
        case "2":
            day = "Terça";
        break;
        case 3:
        case "3":
            day = "Quarta";
        break;
        case 4:
        case "4":
            day = "Quinta";
        break;
        case 5:
        case "5":
            day = "Sexta";
        break;
        case 6:
        case "6":
            day = "Sábado";
        break;
        case 0:
        case "0":
        default:
            day = "Domingo";
        break;
    }
    return day;
}

export function hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export function getGuid() {
    //eslint-disable-next-line
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        //eslint-disable-next-line
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
}
export function isNullOrEmpty(val) {
    return val===null||val===""||val==="0";
}

export function getCaretIndex(element, targetInput) {
    let position = 0;
    const isSupported = typeof window.getSelection !== "undefined";
    if (isSupported) {
        const selection = window.getSelection();
        if (selection.rangeCount !== 0) {
            const range = window.getSelection().getRangeAt(0);
            const preCaretRange = range.cloneRange();
            console.log("preCaretRange 1", preCaretRange);
            preCaretRange.selectNodeContents(element);
            console.log("preCaretRange 2", preCaretRange);
            preCaretRange.setEnd(range.endContainer, range.endOffset);
            console.log("preCaretRange 3", preCaretRange);
            position = preCaretRange.toString().length;
            // targetInput 
        }
    }
    return position;
}

export function getCaretPosition(element) {
  let position = 0;
  const isSupported = typeof window.getSelection !== "undefined";
  if (isSupported) {
    const selection = window.getSelection();
    // Check if there is a selection (i.e. cursor in place)
    if (selection.rangeCount !== 0) {
      // Store the original range
      const range = window.getSelection().getRangeAt(0);
      // Clone the range
      const preCaretRange = range.cloneRange();
      // Select all textual contents from the contenteditable element
      preCaretRange.selectNodeContents(element);
      // And set the range end to the original clicked position
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      // Return the text length from contenteditable start to the range end
      position = preCaretRange.toString().length;
    }
  }
  return position;
}